import { type ReactNode } from 'react'
import { Dialog } from '@base-ui/react/dialog'
import './Modal.css'

interface Props {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  width?: number
  // Скрыть крестик (×), если в теле уже есть дублирующая кнопка закрытия.
  hideClose?: boolean
}

// ESC, клик по бэкдропу и focus-trap — из коробки Base UI. Триггер остаётся на
// странице, поэтому Dialog.Trigger не используем — управляем через open/onOpenChange.
export function Modal({ open, onClose, title, children, width = 480, hideClose = false }: Props) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop className="modal-backdrop" />
        <Dialog.Popup className="dialog" style={{ maxWidth: `${width}px` }}>
          {title ? (
            <header className="dialog__header">
              <Dialog.Title className="dialog__title">{title}</Dialog.Title>
              {hideClose ? null : (
                <Dialog.Close className="dialog__close" aria-label="Закрыть">
                  ×
                </Dialog.Close>
              )}
            </header>
          ) : null}
          <div className="dialog__body">{children}</div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
